import {useState} from 'react';
import get from 'lodash/get';

import Dialog from '@mui/material/Dialog';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import useUser from '../../hooks/useUser';
import SessionForm from './SessionForm';
import SessionFormV2 from './SessionFormV2';
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

const EditSessionButton = props => {
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const user = useUser();
  const isPatient = get(user, 'is_patient') || false;
  const {iconOnly, textOnly, session} = props;
  const childProps = {
    onClick: () => setDialogIsOpen(true),
    disabled: false,
    variant: iconOnly ? null : (props.variant || 'contained'),
    color: iconOnly ? 'primary' : undefined,
    startIcon: iconOnly || textOnly ? null : <EditIcon/>,
    fullWidth: props.fullWidth || null,
    size: props.size
  };
  const onClose = () => setDialogIsOpen(false);
  // Patients can no longer edit sessions
  if (isPatient) return null;
  const sessionVersion = (
    session.appointment_scheduled.session_type.session_type_version === '2.0'
    ? '2.0'
    : '1.0'
  );
  const CorrectForm = sessionVersion === '2.0' && !isPatient 
    ? SessionFormV2 
    : SessionForm;
  const formProps = sessionVersion === '2.0' && !isPatient
    ? {
      session, // TODO: Add isPatient version
      onClose,
      onSubmitted: props.onSubmitted,
      isEditing: true,
    } :
    {
      isPatient,
      session,
      onClose,
      onSubmitted: props.onSubmitted,
    }
  ;
  return (
    <>
      <Dialog
        open={dialogIsOpen}
        fullWidth={true}
        maxWidth='md'
        onClose={onClose}
      >
        {
          session
          ? <CorrectForm {...formProps} />
          : <></>
        }
      </Dialog>
      {
        iconOnly
        ? <Tooltip title='Edit Session'>
          <IconButton {...childProps}>
            <EditIcon/>
          </IconButton>
        </Tooltip>
        : <Button {...childProps}>
            Edit Session
        </Button>
      }
    </>
  );
};

export default EditSessionButton;
